import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LegacyPackingSlip from './LegacyPackingSlip';
import HistoryItemRequisition from './HistoryItemRequisition';
import withWorkflow from '../components/withWorkflow';
import OrderStatus, { OrderStatuses, getOrderStatusText } from './OrderStatus';
import CollectionPackStatus from './CollectionPackStatus';
import { canAuthorizeHistoryOrder } from '../util/gearOrderUtil';
import {fetchPackingSlipNo, requestReorder} from "../util/apiUtils";
import {Result} from "antd";
import Modal from '../components/Modal';
import SendActivationEmail from './SendActivationEmail';

/**
 * Represents a line item in the order list.
 */
class HistoryItem extends Component {
	
	/**
	 * Constructor sets up the state and binds the functions.
	 */
	constructor(props) {
		super(props);
		
		this.state = {
			gearOrder: null,
			displayRemoveRequisition: false,
			orderStatusLink: "",
			reorderModalVisible: false,
			reorderConfirmationScreen: false,
			reorderStatus: "",
			reorderGearReqs: [],
			packingSlipNo: ""
		}
		
		this.viewOrder = this.viewOrder.bind(this);
		this.viewPackingSlip = this.viewPackingSlip.bind(this);
		this.removeRequisitionResponseHandler = this.removeRequisitionResponseHandler.bind(this);
	}
	
	/**
	 * Formats a date in MM/dd/yyyy format.
	 */
	formatDate(date) {
		if (date) {
			return date.monthValue + "/" + date.dayOfMonth + "/" + date.year;
		}
		
		return null;
	}

	/**
	 * Determines which eReq link is needed and returns it
	 */
	getEreqLink = () => {
		const orderType = this.props.getOrderType(this.props.order);

		let link;

		if (orderType === this.props.types.OFFICE) {
			link = <a href="# " onClick={this.viewPackingSlip}>View Order Details</a>
		} else {
			// link = <Link to={`/view/${this.props.order.gearOrderId}`} target='_blank'>View Customized Registration</Link>
			link = <a href="# " onClick={this.viewOrder}>View Online Registration</a>
		}
			
		return <li key="ereq">{link}</li>;
	}
	
	/**
	 * Opens an electronic requisition PDF.
	 */
	viewOrder(event) {
		event.preventDefault();
		fetch().then(() => {
        	window.open(process.env.REACT_APP_GEAR_REST_URL + "/packing-slip/order/" + this.props.order.gearOrderId, "_blank");
        });
	}	
	
	viewPackingSlip(event) {
		event.preventDefault();
		this.setState({
			gearOrder:  this.props.order,
			displayPackingSlip: true
		});
		
	}	

	showActivationEmailModal = () => {
		this.setState({
			displayActivationEmailModal: true
		})
	}	

	hideActivationEmailModal = () => {
		this.setState({
			displayActivationEmailModal: false,
			activationEmailModalLoading: false
		})
	}

	/**
	 * Hide the Activation Email modal after a 1 second delay.
	 * This gives the modal time to briefly show a success message before it is closed.
	 */
	hideActivationEmailModalAfterDelay = () => {
		setTimeout(this.hideActivationEmailModal, 1000);
	}

	handleActivationEmailLoading = (loading) => {
		this.setState({
			activationEmailModalLoading: loading
		})
	}

	/**
	 * A Modal will call this method when an attempt is made to close the Modal by clicking
	 *  outside or pressing 'Escape'.
	 * Prevent the event propagation and return false to disable auto-close behavior.
	 */
	preventModalClose = (evt) => {
		evt?.preventDefault && evt.preventDefault();
		return false;
	};
	
	/**
	 * Handles the response from removing a requisition from an order.
	 *
	 * @param gearReqId the gear requisition id
	 * @param gearOrderId the gear order id
	 */
	removeRequisitionResponseHandler(gearReqId, gearOrderId) {
		this.props.removeRequisitionResponseHandler(gearReqId, gearOrderId);
	}

	confirmReorderSelection = () => {
		if (this.state.reorderGearReqs?.find(req => req.isResubmittal && !req.xComId)) {
			this.setState({reorderStatus: "Please provide a resubmittal order QA, AccessionNo or STAR"});
		} else {
			this.setState({
				reorderModalVisible: false,
				packingSlipNo: "",
				packingSlipError: false,
			});

			this.props.setLoading(true);
			requestReorder(this.props.order.gearOrderId, this.state.reorderGearReqs)
			.then(() => {
				this.setState({reorderConfirmationScreen: true, reorderStatus: "success"})
				fetchPackingSlipNo(this.props.order.gearOrderId)
					.then(text => this.setState({ packingSlipNo: text, packingSlipError: !text }))
					.catch((e) => this.setState({ packingSlipError: true }))
			})
			.catch((e) => {
				this.setState({reorderConfirmationScreen: true, reorderStatus: "error"})
				return false;
			})
			.finally(() => {
				this.props.setLoading(false);
				return true;
			});
		}
	}

	closeReorderSelection = () => {
		this.setState({ reorderGearReqs: [] });
		this.setState({ reorderModalVisible: false });
	}

	hideReorderConfirmation = () => {
		this.setState({reorderConfirmationScreen: false})
	}

	openReorderModal = (event) => {
		event.preventDefault();
		this.setState({ reorderModalVisible: true, reorderStatus: "" });
	}

	handleModalCheckbox = (event) => {
		const value = Number(event.target?.value);
		const requisition = this.props.order?.requisitions?.find(req => req.gearRequisitionId === value)
		const isResubmittal = !!requisition?.accessionNo;

		if (event.target?.checked) {
			this.setState((prevState) => ({
				reorderGearReqs: [...prevState.reorderGearReqs, {
					gearReqId: value,
					isResubmittal: isResubmittal,
					xComId: '',
					patientInstructions: ''
				}]
			}));
		} else {
			this.setState((prevState) => ({
				reorderGearReqs: prevState.reorderGearReqs.filter(i => i?.gearReqId !== value)
			}));
		}
	}

	handleModalRadio = (event) => {
		const value = event.target?.value;
		const gearReqId = Number(event.target?.name?.split('-')[0]);
		const checked = value === 'yes';

		this.setState(prevState => {
			const reorderReq = prevState.reorderGearReqs?.find(reorderReq => reorderReq.gearReqId === gearReqId);
			return {
				reorderGearReqs: prevState.reorderGearReqs?.filter(reorderReq => reorderReq.gearReqId !== gearReqId)
				.concat([{...reorderReq, isResubmittal: checked, xComId: '', patientInstructions: ''}])
			}
		});
	}

	handleModalTextFields = (event) => {
		const value = event.target?.value;
		const key = event.target?.name?.split('-')[1];
		const gearReqId = Number(event.target?.name?.split('-')[0]);

		if (key) {
			this.setState(prevState => {
				const reorderReq = prevState.reorderGearReqs?.find(reorderReq => reorderReq.gearReqId === gearReqId);
				return {
					reorderGearReqs: prevState.reorderGearReqs?.filter(reorderReq => reorderReq.gearReqId !== gearReqId)
					.concat([{...reorderReq, [key]: value}])
				}
			});
		}
	}

	/**
	 * Renders the component.
	 */
	render() {
		let requisitionProductRetired = () => {
			let result = false;
			this.props.order.requisitions.forEach(element => {
				if (element.omsOrderableItemRetiredDate !== null && element.omsOrderableItemRetiredDate < new Date().toString()) {
					result = true;
				}
			});
			return result;
		}
		let status = getOrderStatusText(this.props.order);
		let notStartedStep = this.props.order.workflow.steps.find(step => {
			return step.notStarted && this.props.isStepValidForUser(this.props.order, step);
		});
		const practitionerAuthRequired =
			(status === OrderStatuses.MEDICARE_AUTHORIZATION_REQUIRED ||
				status === OrderStatuses.AUTHORIZATION_NEEDED) &&
				canAuthorizeHistoryOrder(this.props.userInfo, this.props.order);

		const highlightOrder = false;
		let menuItems = [];
		let orderStatusLink = null;
		let reqsAvailableForReorder = this.props.order.requisitions.filter(req => (req.patientDropship || req.physicianInTheLoop) && this.props.order.dateConfirmed);

		//these items only apply to GEAR orders
		if (this.props.order.workflow.steps.length > 0) {
			if (practitionerAuthRequired && !requisitionProductRetired()) {
				menuItems.push(<li key="continue"><Link to={"order/" + this.props.order.gearOrderId + "/confirm/"}>Review & Authorize Order</Link></li>);
				orderStatusLink = {
					type: "relative",
					link: "order/" + this.props.order.gearOrderId + "/confirm/"
				};
			}
			if (status === OrderStatuses.RESULTS_READY || status === OrderStatuses.DISCARDED_SPECIMENS || status === OrderStatuses.ACCESSIONED) {
				menuItems.push(<li key="results-ready"><a style={{textDecoration: 'none', color: 'inherit'}} href={`/mygdx/webreporting?orderNo=${this.props.order.requisitions?.find(req => req.accessionNo)?.accessionNo || ''}`}>{status === OrderStatuses.RESULTS_READY ? "View Results" : "View Status"}</a></li>);
				orderStatusLink = {
					type: "absolute",
					link: `/mygdx/webreporting?orderNo=${this.props.order.requisitions?.find(req => req.accessionNo)?.accessionNo || ''}`
				};
			}
			if (
				!requisitionProductRetired() &&
				(
					(notStartedStep &&
						(status === OrderStatuses.IN_PROGRESS ||
							status === OrderStatuses.PROVIDER_ACTIVATION_NEEDED ||
							status === OrderStatuses.WAITING_PATIENT
						)
					) ||
					(!this.props.order.physicianInTheLoop && status === OrderStatuses.COMPLETE)
				)
			) {
				/*
				 * SCR-7916: Link to /confirm unless it is a ShipToOffice order. Then link to first incomplete step.
				 */
				let notStartedRoute;
				if (this.props.order.requisitions?.some(req => req?.shipToOffice)) {
					notStartedRoute = Object.values(this.props.workflowMetaData).find((step) => step.id === notStartedStep.id).route;
				}
				if (!notStartedRoute) {
					notStartedRoute = 'confirm';
				}

				menuItems.push(<li key="continue"><Link to={"order/" + this.props.order.gearOrderId + "/" + notStartedRoute + "/"}>Continue</Link></li>);
				orderStatusLink = {
					type: "relative",
					link: "order/" + this.props.order.gearOrderId + "/" + notStartedRoute + "/"
				};
			}

			if (this.props.userInfo.adminUser === 'true' && reqsAvailableForReorder?.length) {
				menuItems.push(
					<li key="reorder-pack">
						<a
							href="# "
							style={{ textDecoration: 'none', color: 'inherit' }}
							onClick={this.openReorderModal}
						>
							Reorder Pack
						</a>
					</li>
				);
			}

			// Show Summary link for PITL orders
			if (this.props.order.physicianInTheLoop && this.props.order.dateConfirmed && status !== OrderStatuses.CANCELED ) {
				let linkText = "View Summary";
				if (status === OrderStatuses.DISCARDED_SPECIMENS) {
					linkText += "/Recollect";
				}
				menuItems.push(<li key="summary"><Link to={"order/" + this.props.order.gearOrderId + "/summary"}>{linkText}</Link></li>);
				orderStatusLink = {
					type: "relative",
					link: "order/" + this.props.order.gearOrderId + "/summary"
				}
			}

			// Always show the eReq link for Gear orders
			menuItems.push(this.getEreqLink());
		} else {
			if (!this.props.order.gearOrderId && this.props.order.requisitions?.[0]?.reqNumber && (status === OrderStatuses.IN_PROGRESS || status === OrderStatuses.PROVIDER_ACTIVATION_NEEDED)) {
				menuItems.push(<li key="activate"><Link to={"order/new/pract"}>Activate</Link></li>);
				orderStatusLink = {
					type: "relative",
					link: "order/new/pract"
				}
			}
			if (this.props.order.packingSlip?.length > 0) {
				menuItems.push(<li key="processing"><a href="# " onClick={this.viewPackingSlip}>View Order Details</a></li>);
			} 
		}
		let trackingString = "";
		if (this.props.order.trackingInformation.trackingNumberList.length > 0) {
			let nextNumber = "";
			for (var i = 0; i < this.props.order.trackingInformation.trackingNumberList.length; i++) {
				if (i === 0) {
					nextNumber = this.props.order.trackingInformation.trackingNumberList[i];
				} else {
					nextNumber = "," + this.props.order.trackingInformation.trackingNumberList[i];
				}
				trackingString += nextNumber;
			}
			
			menuItems.push(<li key="track"><a href={"https://www.fedex.com/fedextrack/?action=track&tracknumbers="+trackingString} target="_blank" rel="noopener noreferrer">Track Order</a></li>);
		}

		// Show "Send Activation Email" if activation is not complete and at least one req has an OmsRequisitionId
		if (
			status !== OrderStatuses.COMPLETE &&
			status !== OrderStatuses.PROCESSING &&
			status !== OrderStatuses.CANCELED &&
			status !== OrderStatuses.ACCESSIONED &&
			status !== OrderStatuses.RESULTS_READY &&
			status !== OrderStatuses.DISCARDED_SPECIMENS &&
			this.props.order?.requisitions?.some(gearReq => gearReq?.reqNumber)
		) {
			// eslint-disable-next-line jsx-a11y/anchor-is-valid
			menuItems.push(<li key="activation_email"><a className="cursor-pointer" onClick={this.showActivationEmailModal}>Send Activation Email</a></li>)
		}
			
		const requisitions = this.props.order.requisitions.map((req) => (
			<HistoryItemRequisition 
				requisition={req} 
				order={this.props.order} 
				removeRequisitionResponseHandler={this.removeRequisitionResponseHandler}
				setMessage={this.props.setMessage}
				key={req.gearRequisitionId > 0 ? req.gearRequisitionId : req.kitOrderedId}
				status={status}
				activeStars={this.props.activeStars.filter((s) => s === req.accessionNo)}
			/>
		));
		const selectedOrder = this.props.selectedOrderId === this.props.order.gearOrderId.toString();

		// wrapping in a tbody since we can't return 2 adjacent <tr> tags in a component...
		return (
			<tbody style={{ backgroundColor: this.props.index % 2 !== 0 ? "#f9f9f9" : "", border: selectedOrder ? "2px solid #2c5990" : "", fontWeight: selectedOrder ? "bold" : "normal" }}>
				<tr className={"requisition-line" + (highlightOrder ? ' alert-danger' : '')} id={this.props.order.gearOrderId}>
					<td>
						{this.props.order.orderingPractitionerGsdlNo}
					</td>
					<td>
						{this.formatDate(this.props.order.startDate)}
					</td>
					<td>
						{this.props.order.patientName.fullNameLastFirstMiddle}
						<br/>
						{this.formatDate(this.props.order.patientDateOfBirth)}
					</td>
					<td>
						<table className="table table-condensed">
							<colgroup>
								<col style={{width: "75px"}} />
								<col />
								<col style={{width: "65px"}}/>
							</colgroup>
							<tbody>
								{requisitions}
							</tbody>
							<CollectionPackStatus order={this.props.order} trackingString={trackingString} />
						</table>
					</td>
					<td>
						<OrderStatus order={this.props.order} userInfo={this.props.userInfo} orderStatusLink={orderStatusLink} />
					</td>
					<td className="options">
						<div className="dropdown">
							<button className="btn btn-link" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span className="glyphicon glyphicon-option-vertical"></span>
							</button>
							<ul className="dropdown-menu dropdown-menu-right" style={{'minWidth': '270px'}}>
								{menuItems}
							</ul>
						</div>
					</td>
				</tr>
				{this.state.displayPackingSlip && <LegacyPackingSlip order={this.state.gearOrder} modalHidden={() => this.setState({ displayPackingSlip: false })} />}
				{this.state.reorderModalVisible &&
					<Modal
						title="Reorder Packs"
						footerActionEl={<button type="button" className="btn btn-primary" disabled={this.state.reorderGearReqs.length === 0} onClick={this.confirmReorderSelection}>Submit</button>}
						cancelAction="Cancel"
						onCancel={this.closeReorderSelection}
						modalHidden={this.closeReorderSelection}>
						<div className="row">
							<div className="form-group col-xs-12" style={{zIndex: '10'}}>
								<div>
									<span>Please select the Requisitions you want to reorder:</span>
									{this.state.reorderStatus && <div className="alert alert-danger">{this.state.reorderStatus}</div>}
									<div className="form-group col-xs-12 pl-10">
										{reqsAvailableForReorder.map(req => {
											const reorderReq = this.state.reorderGearReqs?.find(
												 r => r?.gearReqId === req.gearRequisitionId);

												 return <div id={`reorder-modal-${req.gearRequisitionId}`} className="col-xs-12 pl-10">
													 <div className="checkbox">
														 <label>
															 <input type="checkbox" id={req.gearRequisitionId}
																	  value={req.gearRequisitionId}
																	  onChange={this.handleModalCheckbox}/>
															 <span>{req.omsOrderableItemName}</span>
														 </label>
													 </div>
													 {reorderReq &&
														  <div className="col-xs-12 pl-10">
															  <label style={{paddingRight: '1em'}} className="control-label"
																		htmlFor="resubmittalRadio">Is
																  this a
																  resubmittal?
															  </label>
															  <label className="radio-inline">
																  <input id={`resubmittal-yes-${req.gearRequisitionId}`}
																			name={`${req.gearRequisitionId}-resubmittalRadio`}
																			type="radio" value="yes"
																			disabled={req?.accessionNo}
																			checked={reorderReq?.isResubmittal}
																			onChange={this.handleModalRadio}/>
																  Yes
															  </label>
															  <label className="radio-inline">
																  <input id={`resubmittal-no-${req.gearRequisitionId}`}
																			name={`${req.gearRequisitionId}-resubmittalRadio`}
																			type="radio" value="no"
																			disabled={req?.accessionNo}
																			checked={!reorderReq?.isResubmittal}
																			onChange={this.handleModalRadio}/>
																  No
															  </label>
														  </div>}
													 {reorderReq?.isResubmittal
														  && <div className="form-group col-xs-12 pl-10">
															  <input id={`resubmittal-text-${req.gearRequisitionId}`}
																		className="form-control" type="text"
																		name={`${req.gearRequisitionId}-xComId`}
																		placeholder="QA, STAR, or Accession Number"
																		maxLength="32"
																		value={reorderReq?.xComId}
																		onChange={this.handleModalTextFields}/>
															  <br/>
															  <textarea id={`resubmittal-patient-instructions-${req.gearRequisitionId}`}
																			className="form-control PatientInstructions"
																			name={`${req.gearRequisitionId}-patientInstructions`}
																			maxLength="512" rows="3"
																			placeholder="Patient Recollection Instructions"
																			value={reorderReq?.patientInstructions}
																			onChange={this.handleModalTextFields}/>
														  </div>}
												 </div>
											 }
										)}
									</div>
								</div>
							</div>
						</div>
					</Modal>
				}
				{this.state.reorderConfirmationScreen &&
					 <Modal
						  title="Reorder Confirmation"
						  confirmAction="Close"
						  onSave={this.hideReorderConfirmation}>
						 <Result
							  status={this.state.reorderStatus}
							  title={this.state.reorderStatus === "success" ? "Your Reorder was successful"
									: "An Error has occurred when processing your Reorder"}
							  subTitle={this.state.reorderStatus === "success" ? ("Order Number: "
									+ this.props.order.gearOrderId) + " " + (this.state.packingSlipNo ? "Packing Slip: "
									+ this.state.packingSlipNo : "")
									: "Please contact support if this error persists."}
							  extra={(this.state.reorderStatus === "success" && this.state.packingSlipError) ? 
								  "An error prevented the packing slip submission. A CSR ticket has been filed to create the order manually."
								  : ""}
						 />
					 </Modal>
				}
				{this.state.displayActivationEmailModal && (
					 <Modal
						  id={'activation-email-modal_' + this.props.order.id}
						  title="Send Activation Email"
						  modalHidden={this.hideActivationEmailModal}
						  doConfirm={this.state.activationEmailModalLoading ? this.preventModalClose : null}
						  hideCloseX={this.state.activationEmailModalLoading}
					 >
						 <SendActivationEmail
							  gearOrder={{
								  id: this.props.order.gearOrderId,
								  email: this.props.order?.patientEmail
							  }}
							  onSuccess={this.hideActivationEmailModalAfterDelay}
							  onCancel={this.hideActivationEmailModal}
							  onLoading={this.handleActivationEmailLoading}
						 />
					 </Modal>
				)}
			</tbody>
		);
	}
}

export default withWorkflow(HistoryItem);
